import { createSelector } from 'reselect';
import { OrderedSet } from 'immutable';

import { ExternalDonationRequestsState } from 'containers/ExternalDonationRequests/reducer';
import { State } from 'reducers';
import { selectPartners } from 'entities/partners/selectors';

import { PartnerRequestsState, initialState } from './reducer';

const selectState = (state: State): PartnerRequestsState =>
  state.get('partnerRequests') || initialState;

export const selectStatusUpdating = createSelector(selectState, (state: PartnerRequestsState) =>
  state.get('statusUpdating')
);

export const selectLoading = createSelector(selectState, (state: PartnerRequestsState) =>
  state.get('loading')
);

export const selectError = createSelector(selectState, (state: PartnerRequestsState) =>
  state.get('error')
);

export const selectFetchParams = createSelector(selectState, (state: PartnerRequestsState) =>
  state.get('fetchParams')
);

export const selectTotals = createSelector(selectState, (state: ExternalDonationRequestsState) =>
  state.get('totals')
);

export const selectDisplayedPartners = createSelector(
  selectPartners,
  selectState,
  (partners, state) => {
    const displayedPartnerIds: OrderedSet<string> = state.get('displayedPartnerIds');
    return displayedPartnerIds
      .map((partnerId) => !!partnerId && partners.get(partnerId))
      .filter((partner) => !!partner && partner.status !== 'Pending');
  }
);
